<template>

<div class="col-lg-12  mb-4">
    
    <v-card flat>
      <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </v-card>
  </div>
  <!-- <LineChartGenerator
    ref="chart"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  /> -->
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
  name: 'LineChart',
  components: {
    apexchart
  },
  mounted(){
    this.getSeriesFromData();
  },
  data() {
    return {
          series: [],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#8B5AF4', '#43D9AF', '#FF7299', '#848484'],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
              text: 'Reaktionsvolumen',
              align: 'left'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: this.getCategories(),
              title: {
                text: 'Zeitpunkt'
              }
            },
            yaxis: {
              min: this.getMinMaxFromdata("min"),
              max: this.getMinMaxFromdata("max")
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: -25,
              offsetX: -5
            }
          }
        }
      },
  /* computed:{
    chart() {
      return this.$refs.chart.getCurrentChart;
    }
  },   */
  props: {
    data:{
        type: Array
    },
  },
  methods:{
    getMinMaxFromdata(type){
      let values = [];
      values.push(this.data.map(e => e.completed))
      values.push(this.data.map(e => e.empty))
      values.push(this.data.map(e => e.partial))
      if(type == "min"){
        return Math.min(values);
      }
      if(type == "max"){
        return Math.max(values);
      }
    },
    getCategories(){
      return this.data.map(e => new Date(e.timestamp).toLocaleDateString('de-DE'));
    },
    getSeriesFromData(){
      
      this.series.push({
        name: "Beantwortet",
        data: this.data.map(e => e.completed)
      });
      this.series.push({
        name: "Nicht beantwortet",
        data: this.data.map(e => e.empty)
      })

      this.series.push({
        name: "Teilweise beantwortet",
        data: this.data.map(e => e.partial)
      })
    }
/*     handleClick(point, event){
      if(event == null) return;
      let indexClicked = event[0].index;
      this.$emit("pointClicked", indexClicked);
    } */
  } 
}
</script>

